import { useEffect, useRef } from 'react'

interface UsePageVisibilityListenerProps {
  disabled?: boolean
  onVisible: () => void
  onHidden: () => void
}

export const usePageVisibilityListener = ({
  disabled = false,
  onHidden,
  onVisible,
}: UsePageVisibilityListenerProps) => {
  const onVisibleRef = useRef(onVisible)
  const onHiddenRef = useRef(onHidden)

  useEffect(() => {
    onVisibleRef.current = onVisible
  }, [onVisible])

  useEffect(() => {
    onHiddenRef.current = onHidden
  }, [onHidden])

  useEffect(() => {
    if (disabled) return

    const handleVisibilityChange = () => {
      if (document.hidden) {
        onHiddenRef.current()
      } else {
        onVisibleRef.current()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [disabled])
}
